import { useCallback } from 'react';

// Config.
import { env } from 'config';

export enum CertMasterActions {
  Course = 'Course',
  MyCourses = 'MyCourses',
  MySchools = 'MySchools',
  EmployeeTools = 'EmployeeTools',
}

export const useRedirectToCertMaster = (): ((
  action?: CertMasterActions,
  version?: string,
  target?: string,
) => void) => {
  return useCallback(
    (
      action: CertMasterActions = CertMasterActions.Course,
      version?: string,
      target?: string,
    ) => {
      let path;
      switch (action) {
        case CertMasterActions.Course:
          path = `productviewer/${version}/default`;
          break;
        case CertMasterActions.MyCourses:
          path = `my-courses`;
          break;
        case CertMasterActions.MySchools:
          path = `mycampus`;
          break;
        case CertMasterActions.EmployeeTools:
          path = `employeetools`;
          break;
      }

      window.open(
        'https://' +
          [env.CERTMASTER_SSO_HOST.replace('https://', ''), path]
            .join('/')
            .replace(/\/\//g, '/'),
        target || '_blank',
      );
    },
    [],
  );
};
